import { Menu } from 'antd';
import { useContext, useMemo } from 'react';
import { GlobalContext } from '../../utils/globalContext';
import { useNavigate } from 'react-router-dom';

const DashboardMenu = () => {
  const {
    menuRoutes: { menuData },
    menuKeys,
    setMenuKeys,
    user,
  } = useContext(GlobalContext);

  const navigate = useNavigate();

  const onClick = (e) => {
    setMenuKeys(e.keyPath);
    navigate(`/${e.key}`);
  };

  // useMemo to compute openKeys only when dependencies change
  const openKeys = useMemo(() => {
    return user.clie_tipo !== 0 ? menuData : null;
  }, [user.clie_tipo, menuData]);

  return <Menu onClick={onClick} selectedKeys={menuKeys} theme="dark" mode="horizontal" items={openKeys} />;
};

export { DashboardMenu };
